import { makeAutoObservable, toJS } from 'mobx'
import type { IParamsQuickLinkTemplate } from 'entities/QuickLink/api'

export type IQuickLinkPayload = QuickLinkPayload

export class QuickLinkPayload {
  static Create(label: string, url: string) {
    const payload = new QuickLinkPayload()
    payload._label = label
    payload._url = url

    return payload
  }

  private _label = ''
  private _url = ''
  private _mergeFieldsCount = 0
  private _errorUrlMessage = ''

  constructor() {
    makeAutoObservable(this)
  }

  get label() {
    return this._label
  }

  get url() {
    return this._url
  }

  get isLabelEmpty() {
    return !this._label.trim().length
  }

  get isUrlEmpty() {
    return !this._url.trim().length
  }

  get isEmpty() {
    return this.isLabelEmpty || this.isUrlEmpty
  }

  get mergeFieldsCount() {
    return this._mergeFieldsCount
  }

  get errorUrlMessage() {
    return this._errorUrlMessage
  }

  setLabel(label: string) {
    this._label = label
  }

  setUrl(url: string) {
    this._url = url
  }

  setMergeFieldsCount(count: number) {
    this._mergeFieldsCount = count
  }

  setErrorUrlMessage(message: string) {
    this._errorUrlMessage = message
  }

  resetErrorUrlMessage() {
    this._errorUrlMessage = ''
  }

  toJSON(): IParamsQuickLinkTemplate {
    return toJS({
      label: this._label,
      url: this._url,
    })
  }

  copy() {
    const quickLink = new QuickLinkPayload()
    quickLink._label = this._label
    quickLink._url = this._url

    return quickLink
  }
}
